import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "breadcrumb-item-wrapper" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "breadcrumb-item__label" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "breadcrumb-item__button" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-edit me-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getBreadcrumbs(), (item) => {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("button", {
        onClick: ($event: any) => (_ctx.changeStep(item.step)),
        class: "breadcrumb-item"
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1),
        _createElementVNode("span", {
          class: "breadcrumb-item__value",
          innerHTML: item.value
        }, null, 8, _hoisted_4),
        _createElementVNode("span", _hoisted_5, [
          _hoisted_6,
          _createTextVNode(_toDisplayString(item.buttonText), 1)
        ])
      ], 8, _hoisted_2)
    ]))
  }), 256))
}